import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {EntitlementRoleLogsCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const entitlementRoleChangeLogStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementRoleLogsCriteria
>('entitlementRoleChangeLogState', undefined);

export const entitlementRoleChangeLogStateActions = entitlementRoleChangeLogStateSlice.actions;
export const entitlementRoleChangeLogStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementRoleLogsCriteria
> = state => state.manageEntitlements.entitlementRoleChangeLogReducer.state;
